import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContentSetContentRoutingModule } from './content-set-content-routing.module';
import { ContentSetContentFormComponent } from './components/content-set-content-form/content-set-content-form.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SharedFormSectionsModule } from '../shared-form-sections/shared-form-sections.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [ContentSetContentFormComponent],
  imports: [
    CommonModule,
    ContentSetContentRoutingModule,
    SharedModule,
    SharedFormSectionsModule,
    MatSnackBarModule,
    MatDialogModule,
  ],
})
export class ContentSetContentModule {}
